<script setup>
import { Head, Link, router, usePage } from '@inertiajs/vue3';
import ApplicationMark from "@/Components/ApplicationMark.vue";
import Button from 'primevue/button';
import { onBeforeMount } from 'vue';


defineProps({
    canLogin: {
        type: Boolean,
    },
    canRegister: {
        type: Boolean,
    },
    laravelVersion: {
        type: String,
        required: true,
    },
    phpVersion: {
        type: String,
        required: true,
    },
});

const { user } = usePage().props?.auth
onBeforeMount(() => {
    if (user) {
        if (user.is_guest) {
            router.get('/orders/create')
        } else {
            router.get('/dashboard')
        }
    }
})

</script>

<template>
    <Head title="DIVAM - Bienvenue"/>
    <section class="light:bg-gray-100 h-screen flex flex-col justify-between">
        <main class="flex flex-col justify-evenly items-center h-full">
            <ApplicationMark
                class="w-min"
                :class="user && 'animate-pulse'"
            />
            <nav v-if="canLogin && !user" class="flex flex-col w-fit space-y-4">
                <Link
                    :href="route('login')"
                >
                    <Button class="w-full" label="Se connecter" icon="pi pi-sign-in" icon-pos="right"/>
                </Link>
                <Link
                    v-if="canRegister"
                    :href="route('register')"
                    >
                    <Button class="w-full" label="S'inscrire" icon="pi pi-user-plus" icon-pos="right"/>
                </Link>
                <Link
                    :href="route('login-as-guest')"
                >
                    <Button class="w-full" label="Code invité" icon="pi pi-sign-in" icon-pos="right"/>
                </Link>
                <Link
                    :href="route('unauthenticated.contact')"
                >
                    <Button outlined label="Contacter Divam" icon="pi pi-envelope" icon-pos="right"/>
                </Link>
            </nav>
        </main>

        <footer class="py-2 text-center text-sm text-gray-400 dark:text-white/70">
            Divam experience
        </footer>
    </section>
</template>
